import { Cascader, CascaderProps } from 'antd';
import { Tag } from './type';
import { getSpuClassTags } from './service';
import { useMemo } from 'react';
import { cutTag, extractTagName, mergeIf, useTagTransName } from './util';
import { useQuery } from '@tanstack/react-query';
import { map, flattenDeep, forEach } from 'lodash-es';
import { getTranslate } from './trans';

interface TagSelectProps extends CascaderProps<Tag> {
  spuClassId?: number;
  tags?: Tag[];
  extraTag?: Tag;
}

export const TagSelect = (props: TagSelectProps) => {
  const { spuClassId, extraTag, tags, ...restProps } = props;
  const { data: data1, isLoading: loading1 } = useQuery({
    queryKey: ['getSpuClassTags', spuClassId] as const,
    queryFn: ({ queryKey }) => {
      return getSpuClassTags(queryKey[1]!).then((res) => {
        const list = map(res, extractTagName);
        const needToTranslate = flattenDeep(list);

        return Promise.all(
          needToTranslate.map((item) => {
            return getTranslate(item);
          }),
        )
          .then((s) => {
            let i = 0;
            forEach(res, (item) => {
              forEach(item.subTags, (sub) => {
                sub.name = s[i++];
                forEach(sub.subTags, (subsub) => {
                  subsub.name = s[i++];
                });
              });
            });
          })
          .then(() => res)
          .catch(() => {
            return res;
          });
      });
    },
    enabled: !!spuClassId,
  });
  const loading = loading1;
  const data = data1 || tags;
  const filterPath = (inputValue: string, path: any[]) => {
    return path.some(
      (option) => (option.name as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
    );
  };
  const getTagName = useTagTransName();
  const cutedData = useMemo(() => {
    const newData = getTagName(data);
    return mergeIf(cutTag(newData), extraTag);
  }, [data, extraTag, getTagName]);

  return (
    <Cascader
      options={cutedData}
      showSearch={{ filter: filterPath }}
      fieldNames={{ label: 'name', value: 'id', children: 'subTags' }}
      loading={loading}
      {...restProps}
    />
  );
};
